<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center justify-space-between>
        <div>
          <v-flex xs12>
            <v-breadcrumbs :items="breadcrumbs">
              <template v-slot:item="props">
                <router-link
                  :to="props.item.href"
                  :is="props.item.disabled ? 'span' : 'router-link'"
                >
                  {{ props.item.text }}
                </router-link>
              </template>
              <template v-slot:divider>
                <v-icon>chevron_right</v-icon>
              </template>
            </v-breadcrumbs>
          </v-flex>
          <v-flex xs12>
            <BoxIcon padding="7px 7px 0px 6px" class="mr-3">
              <img
                style="margin-left: 3px"
                :src="require('@/assets/icons/autorizar.svg')"
              />
            </BoxIcon>
            <h1 style="display: inline">Detalle de ronda</h1>
          </v-flex>
        </div>
        <div>
          <span class="font-weight-medium">{{ name }}</span>
          <br />
          <div>
            <p class="font-weight-medium">
              <span class="max_text_w"> Fecha de inicio </span>
              <v-icon color="black" size="17" class="ml-3 mr-1">event</v-icon>
              <span class="font-weight-medium">{{ startDate }}</span>
            </p>

            <p v-if="endDate !== undefined" class="font-weight-medium">
              <span class="max_text_w"> Fecha de fin </span>
              <v-icon color="black" size="17" class="ml-3 mr-1">event</v-icon>
              <span class="font-weight-medium">{{ endDate }}</span>
            </p>
          </div>
        </div>
      </v-layout>
      <template v-slot:extension>
        <v-tabs
          v-model="currentTab"
          color="transparent"
          style="margin-left: 70px"
        >
          <v-tab v-for="tab in tabs" :key="tab.id">
            <span class="text-uppercase">{{ tab.name }}</span>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-tabs-items v-model="currentTab">
      <v-tab-item>
        <DetailRoundStudent />
      </v-tab-item>
      <v-tab-item>
        <DetailRoundTutor />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import moment from 'moment'
import BoxIcon from '../../../../generic/boxIcon.vue'
import DetailRoundStudent from './details/detailRoundStudent.vue'
import DetailRoundTutor from './details/detailRoundTutor.vue'

export default {
  components: {
    BoxIcon,
    DetailRoundStudent,
    DetailRoundTutor,
  },
  data: () => ({
    currentTab: 0,
    tabs: [
      { id: 1, name: 'ALUMNOS' },
      { id: 2, name: 'TUTORES AUTORIZADOS' },
    ],
    breadcrumbs: [
      {
        text: 'Rondas',
        disabled: false,
        href: '/es/panel/rounds',
      },
      {
        text: 'Detalle',
        disabled: true,
        href: '/es/panel/rounds/detail',
      },
    ],
    name: '',
    startDate: undefined,
    endDate: undefined,
  }),
  mounted() {
    this.setup()
  },
  methods: {
    async setup() {
      try {
        const { data } = await this.$store.dispatch(
          'round/getDetailRound',
          this.$route.params.id
        )
        this.startDate = this._timeParseCapitalize(
          this._parseTime(data.createdAt)
        )
        if (data.expDate !== undefined) {
          this.endDate = this._timeParseCapitalize(
            this._parseTime(data.expDate)
          )
        } else {
          this.endDate = 'Indefinida'
        }

        this.name = data.name
      } catch (error) {
        console.log(error)
      }
    },
    _timeParseCapitalize(time = '') {
      const [day, month, year] = time.split('/')
      const capitalMonth = `${month
        .substring(0, 1)
        .toUpperCase()}${month.substring(1)}`

      return `${day}/${capitalMonth}/${year}`
    },
    /**
     * Return a date like so `24/Jul/2023 `
     */
    _parseTime(date) {
      return moment(new Date(date)).format('DD/MMM/YYYY').replaceAll('.', '')
      // .tz(this.getBrandTZ.timezone)
    },
  },
}
</script>

<style scoped>
.max_text_w {
  width: 100px;
  display: inline-block;
}
</style>
